var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileZip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1697_159)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4375 9.375C19.9197 9.375 19.5 9.79472 19.5 10.3125V21.1875C19.5 21.7044 19.0794 22.125 18.5625 22.125H5.4375C4.92056 22.125 4.5 21.7044 4.5 21.1875V2.8125C4.5 2.29556 4.92056 1.875 5.4375 1.875H13.875V4.6875C13.875 6.23831 15.1367 7.5 16.6875 7.5H20.4375C20.8167 7.5 21.1585 7.27158 21.3037 6.92128C21.4488 6.57098 21.3686 6.16772 21.1005 5.89959L15.4755 0.274687C15.3193 0.113109 15.0709 0 14.8125 0H5.4375C3.88669 0 2.625 1.26169 2.625 2.8125V21.1875C2.625 22.7383 3.88669 24 5.4375 24H18.5625C20.1133 24 21.375 22.7383 21.375 21.1875V10.3125C21.375 9.79472 20.9553 9.375 20.4375 9.375ZM16.6875 5.625C16.1706 5.625 15.75 5.20444 15.75 4.6875V3.20081L18.1742 5.625H16.6875Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0625 11.25C11.5803 11.25 12 10.8303 12 10.3125C12 9.79472 11.5803 9.375 11.0625 9.375H10.125V7.5H11.0625C11.5803 7.5 12 7.08028 12 6.5625C12 6.04472 11.5803 5.625 11.0625 5.625H10.125V4.6875C10.125 4.16972 9.70528 3.75 9.1875 3.75C8.66972 3.75 8.25 4.16972 8.25 4.6875V5.625H7.3125C6.79472 5.625 6.375 6.04472 6.375 6.5625C6.375 7.08028 6.79472 7.5 7.3125 7.5H8.25V9.375H7.3125C6.79472 9.375 6.375 9.79472 6.375 10.3125C6.375 10.8303 6.79472 11.25 7.3125 11.25H8.25V13.125H7.3125C6.79472 13.125 6.375 13.5447 6.375 14.0625C6.375 14.5803 6.79472 15 7.3125 15H8.25V15.9375C8.25 16.4553 8.66972 16.875 9.1875 16.875C9.70528 16.875 10.125 16.4553 10.125 15.9375V15H11.0625C11.5803 15 12 14.5803 12 14.0625C12 13.5447 11.5803 13.125 11.0625 13.125H10.125V11.25H11.0625Z",
    fill: "#202020"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1697_159"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileZip);
export default __webpack_public_path__ + "static/media/file-zip.63315f1ed76c3186ebc1264bb73257d6.svg";
export { ForwardRef as ReactComponent };